/**
 * @description Dydu response type
 */

export default Object.freeze({
  SAML_REDIRECTION: 'SAML_redirection',
})
